// generated by genversion
export var version = '5.1.5';
//# sourceMappingURL=version.js.map